export default __webpack_public_path__ + "static/media/Archpriest's Boots of Balance.3564a31c.jpg";